// @flow
import React from 'react';
import {
  SalesMaterialItemDiv,
  DownloadLinkA,
  BorderDiv,
  DownloadLinkDesktopA,
  SalesMaterialItemHeader,
  SalesMaterialDescription,
  FileNameLabel
} from './MarketingStyle';
import { type MarketingFile } from '.';
import Icon from '../../components/Icon';
import { Desktop, Device } from '../../components/Responsive';
import { TextStyleP } from '../../components/TextStyles';

export const MarketingBody = ({
  marketingFiles,
  downloadFile
}: {
  marketingFiles: MarketingFile[],
  downloadFile: (url: string, fileName: string) => void
}) =>
  marketingFiles.length === 0 ? (
    <TextStyleP color="dustyGray" italics>
      There is no sales material in this category.
    </TextStyleP>
  ) : (
    <div>
      {marketingFiles.map((file, index) => (
        <SalesMaterialItemDiv key={index}>
          <SalesMaterialItemHeader>
            <Icon name="chevronRight" />
            <Device>
              <DownloadLinkA
                onClick={() => downloadFile(file.url, file.name)}
                target="_blank"
                download={`NetCents ${file.name}`}
              >
                <FileNameLabel>{file.name}</FileNameLabel>
              </DownloadLinkA>
            </Device>
            <Desktop>
              <DownloadLinkDesktopA
                onClick={() => downloadFile(file.url, file.name)}
                target="_blank"
                download={`NetCents ${file.name}`}
              >
                <FileNameLabel>{file.name}</FileNameLabel>
                <BorderDiv />
                <span>Download {file.file_type}</span>
              </DownloadLinkDesktopA>
            </Desktop>
          </SalesMaterialItemHeader>
          {file.description && (
            <SalesMaterialDescription>
              <p>{file.description}</p>
            </SalesMaterialDescription>
          )}
        </SalesMaterialItemDiv>
      ))}
    </div>
  );
